<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <!--    <ul class="nav navbar-nav d-xl-none">-->
    <!--      <li class="nav-item">-->
    <!--        <b-link-->
    <!--          class="nav-link"-->
    <!--          @click="toggleVerticalMenuActive"-->
    <!--        >-->
    <!--          <feather-icon-->
    <!--            icon="MenuIcon"-->
    <!--            size="21"-->
    <!--          />-->
    <!--        </b-link>-->
    <!--      </li>-->
    <!--    </ul>-->

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <div>
        <img
          class="logo"
          src="@/assets/images/logo/logo.png"
          alt=""
        >
        <label class="ml-1">Archistar - {{ title }}</label>
      </div>
    </div>

    <div>
      <DarkToggler class="d-none d-lg-block pr-2" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <h5 class="user-name font-weight-bolder mb-0">
              {{ currentUser | ucfirst }}
            </h5>
            <h5 class="user-status">
              {{ userType | ucfirst }}
            </h5>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/placeholder.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <!--        <b-dropdown-item link-class="d-flex align-items-center">-->
        <!--          <font-awesome-icon-->
        <!--            icon="user"-->
        <!--          />-->
        <!--          <span class="ml-1">Profilo</span>-->
        <!--        </b-dropdown-item>-->
        <b-dropdown-item
          v-if="$can('manage_users', 'object')"
          link-class="d-flex align-items-center"
          @click="goToAdmin"
        >
          <font-awesome-icon
            icon="user-plus"
          />
          <span class="ml-1">Admin</span>
        </b-dropdown-item>
        <b-dropdown-item
          v-if="canViewDeletedReport"
          :to="{ name: 'deleted-report' }"
          link-class="d-flex align-items-center text-wrap"
        >
          <feather-icon
            icon="FileTextIcon"
            size="16"
            class="mr-50 flex-shrink-0"
          />
          <span>Report cartelle eliminate</span>
        </b-dropdown-item>
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="openFtpCredentials"
        >
          <feather-icon
            icon="ServerIcon"
            size="16"
            class="mr-50 flex-shrink-0"
          />
          <span>Dati FTP</span>
        </b-dropdown-item>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="MailIcon" class="mr-50" />
          <span>Inbox</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
          <span>Task</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
          <span>Chat</span>
        </b-dropdown-item> -->

        <b-dropdown-divider
          v-if="$can('manage_users')"
        />

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span @click="logout">Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

    <FtpCredentialsModal />
  </div>
</template>

<script>
import {
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import authStore from '@/services/authStore'
import { isUserTypeAllowed } from '@/helpers/nav-filter'
import { REPORT_USER_TYPES } from '@/helpers/deleted-report-helpers'
import FtpCredentialsModal from './modals/FtpCredentialsModal.vue'

export default {
  components: {
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,
    FtpCredentialsModal,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    const { userType, currentUser } = authStore()
    // Advisory only: the backend answers 403 to every other profile (D-02, D-03).
    const canViewDeletedReport = computed(() => isUserTypeAllowed(REPORT_USER_TYPES, userType.value))
    return {
      userType,
      currentUser,
      canViewDeletedReport,
    }
  },
  computed: {
    title() {
      return localStorage.getItem('title')
    },
  },
  methods: {
    logout() {
      // console.log("logout");
      this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    },
    goToAdmin() {
      this.$router.push('/user')
    },
    openFtpCredentials() {
      this.$bvModal.show('ftp-credentials-modal')
    },
  },
}
</script>
<style >
.logo{
  width: 24px;
}
</style>
